import { useCallback } from "react";
import Helpers from "../../../constants/helpers";
import { ModelPortfolioType, RequestDownloadDocument } from "../../../constants/modelPortfoliosConstants";
import { Resources } from "../../../constants/constants";

const useGetDownloadDocUrl = () => {
    const getDownloadDocUrl = useCallback((id, downloadUrl) => {
        const GetDRPRulesDocumentUrl = (modelPortfolioId) => {
            switch (modelPortfolioId) {
                case ModelPortfolioType.INES:
                    return Helpers.getBlobFileUrl(Resources.Common.DRP_RULES.INES_DRP);
                case ModelPortfolioType.INIF:
                    return Helpers.getBlobFileUrl(Resources.Common.DRP_RULES.INIF_DRP);
                case ModelPortfolioType.IIGF:
                    return Helpers.getBlobFileUrl(Resources.Common.DRP_RULES.IIGF_DRP);
                case ModelPortfolioType.IISV:
                    return Helpers.getBlobFileUrl(Resources.Common.DRP_RULES.IISV_DRP);
            }

            return '';
        };

        let docUrl = '';
        if (id) {
            switch (id) {
                case RequestDownloadDocument.InvestorPack:
                    docUrl = Helpers.getBlobFileUrl(Resources.Common.InvestorPacks.DEFAULT);
                    break;
                case RequestDownloadDocument.Retirement_Report:
                    docUrl = Helpers.getBlobFileUrl(Resources.Paths.RETIREMENT_REPORT);
                    break;
                case RequestDownloadDocument.Wealth_Report:
                    docUrl = Helpers.getBlobFileUrl(Resources.Paths.WEALTH_REPORT);
                    break;
                case RequestDownloadDocument.FeesSpecialReport:
                    docUrl = Helpers.getBlobFileUrl(Resources.Paths.FEE_REPORT_2018);
                    break;
                case RequestDownloadDocument.INES_DRP_Rules:
                    docUrl = GetDRPRulesDocumentUrl(ModelPortfolioType.INES);
                    break;
                case RequestDownloadDocument.INIF_DRP_Rules:
                    docUrl = GetDRPRulesDocumentUrl(ModelPortfolioType.INIF);
                    break;
                case RequestDownloadDocument.IIGF_DRP_Rules:
                    docUrl = GetDRPRulesDocumentUrl(ModelPortfolioType.IIGF);
                    break;
                case RequestDownloadDocument.ETF_Report:
                    docUrl = Helpers.getBlobFileUrl(Resources.EtfReport.CONSUMER_REPORT);
                    break;
                case RequestDownloadDocument.PDS:
                default:
                    docUrl = downloadUrl;
            }
        }
        
        return docUrl;

    }, []);

    return getDownloadDocUrl;
};
export default useGetDownloadDocUrl;
